import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import CurrentUser from '../CurrentUser'
import { Loader } from 'stylist'

const RouteIfAdmin = ({ component: Component, failRedirect, ...rest }) => (
  <Route
    {...rest}
    render={props => (
      <CurrentUser
        render={({ loading, viewer }) => {
          if (loading) {
            return <Loader size="lg" data-testid="loader" centered />
          } else if (viewer && viewer.is_admin) {
            return <Component {...props} />
          }
          return <Redirect to={failRedirect} />
        }}
      />
    )}
  />
)

export default RouteIfAdmin



// WEBPACK FOOTER //
// ./src/components/RouteIfAdmin/index.js